<template>
	<div class="row wrapper">
        <div class="image_login col-lg-7">
            <div class="container">
                <img src="../assets/image/login-img.png" class="login_img" alt="">
            </div>
        </div>
        <div class="login_form col-lg-5 my-auto">
            <div class="container">
                <h1 class="title">
                    Forgot <br>
                    Password
                </h1>

                <div class="spacer-lg"></div>
                
                <form name="form" @submit.prevent="resetPassword()">
                    <div class="form-group">
                        <div v-if="message" class="alert alert-danger" role="alert">{{message.message}}</div>
                    </div>
                    <div class="form-group">
                        <div class="input">
							<input type="text" v-model="email" v-validate="'required|email|max:50'" name="email" class="form-control" placeholder="Email">
							<i class='bx bx-envelope'></i>
						</div>
                        <div v-if="submitted && errors.has('email')" class="text-danger">
                            {{errors.first('email')?'Email Required': ''}}
                        </div>
                    </div>
					<div class="row">
						<div class="col-4">
							<router-link to="/login" class="btn btn_outline_red btn-block">Cancel</router-link>
						</div>
						<div class="col-8">
							<button class="btn btn_red btn-block" type="submit" id="btn-forget" :disabled="loading">
								<span v-show="loading" class="spinner-border spinner-border-sm"></span>
								<!-- <img v-show="!loading" src="../assets/image/login_icon.svg" class="mr-2" alt=""> -->
								<span v-show="!loading">Reset Password</span>
							</button>
						</div>
					</div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'
export default {
	data() {
		return {
			confirmation_path: window.location.origin +process.env.VUE_APP_PUBLIC_PATH+ "resetpassword",
			email: '',
			message: '',
			loading: false,
			submitted: false,
		}
	},
	mounted(){
		// console.log('Path : ', this.confirmation_path);
	},
	methods : {
		resetPassword() {
			this.loading = true;
			this.submitted = true;
			document.getElementById("btn-forget").disabled = true;
			const data = new FormData()
			data.append('email', this.email)
			data.append('confirmation_path', this.confirmation_path)

			this.$validator.validate().then(isValid => {
				if(isValid){
					axios.post("/investor/auth/forgetpassword/", data)
					.then(() => {
						// console.log(response)
						swal('Email has been send', 'please click link in it to procced further.', 'success', {
							button: "OK"
						})
						this.loading = false;
						this.$router.push('/login')
					}).catch((error)=>{
						// console.log(error)
						this.loading = false;
						swal('Sorry,,,,', error.data.message, 'error')
						document.getElementById("btn-forget").disabled = false;
					})
				} else{
					this.loading = false;
				}
			})

		}
	}
}
</script>

<style>

</style>